module.exports = __webpack_public_path__ + "img/logo-pc.1d3124ee.png";